import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { QuickPanelService } from "./quick-panel.service";
import { lang_notificaciones } from 'app/idiomas/i18n/notificaciones/notificaciones.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { AuthService } from 'app/auth/auth.service';
import { Router } from '@angular/router';

@Component({
    selector     : 'quick-panel',
    templateUrl  : './quick-panel.component.html',
    styleUrls    : ['./quick-panel.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class QuickPanelComponent implements OnInit
{
    date: Date;
    events: any[];
    notes: any[];
    settings: any;
    idiomaActual:string;
    notificaciones: any[];
    userData:any;

    validationUser:boolean=false;
    mostrarBtnHistori:boolean=false;
    empresaId:string;
    tiposProductos: any;
    aniosProductos: any;

    notifEmpresa:boolean;

    notificacionesGenerales:any[]=[];


    /**
     * Constructor
     */
     minMostrar=10;
     mostrarMasNotif=false;
     urlHistoryProduct:string;
    constructor(
      private qps: QuickPanelService,
      private translateSrv: TranslateService,
      private _fuseTranslationLoaderService: FuseTranslationLoaderService,
      public authService: AuthService,
      private router: Router,
    ) {
        // Set the defaults
        this.date = new Date();
        this.settings = {
            notify: true,
            cloud : false,
            retro : true
        };
        lang_notificaciones.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
        });

        this.idiomaActual = this.translateSrv.currentLang;
        this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });

        this.qps.actualizaNotif.subscribe( (respuesta) => {
          if(respuesta){
            this.getNotificaciones();

          }
        });

        this.qps.actualizaHistorialNotif.subscribe( (respuesta) => {
          if(respuesta){
            if (localStorage.getItem('companyID')!='0') {
              this.getNotificacionesEmpresaId("0");
              // console.log("entro como empresa ");
            }else{
              // console.log("no hace nada ");
            }

          }
        });






        this.authService.mensajeActualQuick.subscribe( (resu:any) => {
        // console.log('resu',resu);
        let actualizar:any=resu.actua;
        let nivel:any=resu.nivelNotif;
        if(actualizar== "100"){
          // console.log("entro este  visne ajuuuuuaaaaaaa");
          switch (nivel) {
            case 1:
            // console.log("No se actualiza nada ");
            break;
            case 2:
            this.getNotificacionesEmpresaId(nivel);
            break;
            case 3:
            this.getNotificacionesEmpresaId(nivel);
            break;

            default:

            break;
          }
        }
        });
    }

    ngOnInit() {
      this.empresaId=localStorage.getItem('companyID');
      // console.log('empresa id  es::::',this.empresaId);

      this.qps.getNotificaciones().subscribe((respuesta:any) => {
        // console.log("getNotifs:",respuesta);
        if(respuesta.success){
          this.notificaciones = respuesta.notificacionGral;
        }
      });
      this.urlHistoryProduct='history/producto'

    }

    getNotificaciones(){
      this.qps.getNotificaciones().subscribe((respuesta:any) => {
        // console.log("getNotifs:",respuesta);
        if(respuesta.success){
          respuesta.notificacionGral.sort( (a,b) => { if(a.fechaCreacion < b.fechaCreacion){ return 1; } else{ return -1; } });
          this.notificaciones = respuesta.notificacionGral;
          this.notificaciones.forEach(element => {
            element.vivo = 1;
          });
        }

        this.notifEmpresa=false;
      });
    }



    verNotif(idNotif: string, indice: number, status: boolean, vivo:number){
      this.qps.updateNotificacion(status,vivo,idNotif).subscribe((respuesta:any) => {
        // console.log("respUpdNot:",respuesta);
        this.notificaciones[indice].status = status;
        this.notificaciones[indice].vivo = vivo;
      });
    }


    getNotificacionesEmpresaId(nivel){
    // console.log("lamando a llamar");
       let producto:any={};
       let fechaProducto:any={};
       this.notificacionesGenerales=[];
       // if (this.userData.level==3 || this.userData.level==2) {
       //   this.mostrarBtnHistori=true;
       // }else{
       //   this.mostrarBtnHistori=false;
       // }
      this.qps.getNotificacionesEmpresaID(localStorage.getItem('companyID')).subscribe((respuesta:any) => {
        // console.log("getNotifsProductoId:",respuesta);
        this.notifEmpresa=true;
        respuesta.historial.forEach(tipProduct => {
          if (tipProduct.historial.length>0) {
            tipProduct.historial.forEach(historialProduc => {
              if (historialProduc.vivo!=2 && historialProduc.levelNotification!=1) {
                historialProduc.productoId=tipProduct.productoId;
                historialProduc.tipoProducto=tipProduct.tipoProducto;
                historialProduc.fechaProducto=tipProduct.fechaProducto;
                this.notificacionesGenerales.push(historialProduc);
              }
            });

          }
        });

        this.notificacionesGenerales.sort( (a,b) => {
          if(a.createdAt > b.createdAt){
            return -1;
          } else{
            return 1;
          }
        });
        // console.log("notificacionesGenerales ",this.notificacionesGenerales);

        if(localStorage.getItem('userBypass')){
        this.userData=JSON.parse(localStorage.getItem('userBypass'));
        // console.log(this.userData.level);
        if(this.userData.level==3 || this.userData.level==2){
          this.mostrarBtnHistori=true;
          this.validationUser=true;
          // console.log('+++++++++++++++Usuario administrador+++++++++++++++ ',this.validationUser);
        }
        else{
          this.validationUser=false;
          this.mostrarBtnHistori=false;
          // console.log('+++++++++++++++Usuario Empresa+++++++++++++++ ',this.validationUser);
        }
        }

        console.log(">>>>>>>>>>>>>>>>>>>mostrarBtnHistori",this.mostrarBtnHistori);
      });
    }

cambiarVivo(productoId:any,notifId:any, vivo:number){
// console.log('Id Notificación',notifId);
let indiceActualizar=this.notificacionesGenerales.findIndex(item => item._id == notifId);
let datos:any;
  if (vivo==0) {
  // console.log('no hace nada');
  datos={vivoStatus:1};
  if (indiceActualizar !=-1) {
    this.notificacionesGenerales[indiceActualizar].vivo=1;
  }
  }else{
  datos={vivoStatus:0};

  if (indiceActualizar !=-1) {
    this.notificacionesGenerales[indiceActualizar].vivo=0;
  }
}
this.qps.updateNotificacionEstatus(productoId,notifId,datos).subscribe((respuesta:any) => {
  // console.log('respuesta',respuesta);
  this.enviaOrdenWizardNotificiaciones();
});

    }

      cambiarVivoOcultar(productoId:any,notifId:any, vivo:number){
  // console.log('Id Notificación',notifId);
  let indiceActualizar=this.notificacionesGenerales.findIndex(item => item._id == notifId);
  let datos={vivoStatus:vivo};
this.notificacionesGenerales.splice(indiceActualizar,1);

  this.qps.updateNotificacionEstatus(productoId,notifId,datos).subscribe((respuesta:any) => {
    // console.log('respuesta',respuesta);
    this.enviaOrdenWizardNotificiaciones();
  });

      }

enviaOrdenWizardNotificiaciones(){
this.authService.puenteDatosNotificacionesToolbar("100"); //100 = actualiza los status de los steps
}

mostrarMas(){
  this.minMostrar=50;
  this.mostrarMasNotif=true;

}
mostrarMenos(){
  this.minMostrar=10;
  this.mostrarMasNotif=false;

}

historialNotif(ruta){
  console.log(ruta);

this.router.navigate([ruta]);
}
}
